import { StatCard } from '../StatCard';

export interface StatisticsCardProps {
  title: string;
  primaryValue: number | string;
  secondaryValue?: number | string;
  trend?: number;
  delta?: number;
  comparison?: string;
  status?: 'success' | 'warning' | 'danger' | 'info';
  icon?: string;
  color?: 'primary' | 'success' | 'warning' | 'error' | 'info';
}

export function StatisticsCard({
  title,
  primaryValue,
  secondaryValue,
  trend,
  delta,
  comparison,
  status,
  icon: _icon,
  color: _color,
}: StatisticsCardProps) {
  return (
    <div className="flex flex-col gap-2 h-full">
      <StatCard
        data={{ 
          label: title, 
          value: primaryValue, 
          trend, 
          status 
        }}
      />
      
      {/* Composition: Render additional properties below the StatCard */}
      {(secondaryValue || trend || comparison) && (
        <div className="bg-surface p-3 rounded-card-sm border border-outline text-body-sm flex justify-between items-center mt-2">
          {secondaryValue && (
            <div className="flex flex-col">
              <span className="text-on-surface-variant text-[10px] uppercase font-bold tracking-wider">Secondary</span>
              <span className="font-medium text-on-surface">{secondaryValue}</span>
            </div>
          )}
          {trend !== undefined && (
            <div className="flex flex-col items-end">
              <span className="text-on-surface-variant text-[10px] uppercase font-bold tracking-wider">Trend</span>
              <span className={`font-medium ${trend >= 0 ? 'text-success' : 'text-danger'}`}>
                {trend >= 0 ? '+' : ''}{trend}%
              </span>
            </div>
          )}
          {delta !== undefined && (
            <div className="flex flex-col items-end">
              <span className="text-on-surface-variant text-[10px] uppercase font-bold tracking-wider">Delta</span>
              <span className={`font-medium ${delta >= 0 ? 'text-success' : 'text-danger'}`}>
                {delta >= 0 ? '+' : ''}{delta}
              </span>
            </div>
          )}
        </div>
      )}
      
      {comparison && (
        <p className="text-xs text-on-surface-variant mt-1 text-center">
          Compared to {comparison}
        </p>
      )}
    </div>
  );
}
